"use client";

import { useWorkflowExamples } from "@/hooks/useInsights";
import { submitPendingPrompt } from "@/lib/workflow/submitPendingPrompt";
import { EASE_OUT_QUART, MOTION_DURATION } from "@/lib/animation-constants";
import { motion, useReducedMotion } from "motion/react";
import { useRouter } from "next/navigation";
import { useMemo } from "react";
import { PromptIdeaPill } from "./PromptIdeaPill";
const FALLBACK_IDEAS = ["Send Telegram alert when ETH price changes by 10%", "Schedule weekly portfolio balance summary by Gmail", "Auto-post daily trading volume to Slack", "Monitor ETH price and send Slack notification", "Monitor, alert large token transfers across multiple chain"];
interface PromptIdeasProps {
  entranceDelay?: number;
  onEntranceComplete?: () => void;
}
export function PromptIdeas({
  entranceDelay = 0,
  onEntranceComplete
}: PromptIdeasProps) {
  const router = useRouter();
  const personalized = useWorkflowExamples();
  const shouldReduceMotion = useReducedMotion();
  const ideas = useMemo<string[]>(() => {
    if (personalized.length === 0) return FALLBACK_IDEAS;
    const personalizedPrompts = personalized.slice(0, 5).map(ex => ex.prompt);
    if (personalizedPrompts.length >= 5) return personalizedPrompts;
    const seen = new Set(personalizedPrompts.map(p => p.toLowerCase()));
    const filler = FALLBACK_IDEAS.filter(f => !seen.has(f.toLowerCase()));
    return [...personalizedPrompts, ...filler].slice(0, 5);
  }, [personalized]);
  return <div className="mx-auto flex w-full max-w-[1024px] flex-wrap items-start justify-center gap-2">
      {ideas.map((prompt, idx) => {
      const isLast = idx === ideas.length - 1;
      return <motion.div key={prompt} initial={shouldReduceMotion ? false : {
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={shouldReduceMotion ? {
        duration: 0
      } : {
        duration: MOTION_DURATION.normal,
        delay: entranceDelay + idx * 0.04,
        ease: EASE_OUT_QUART
      }} onAnimationComplete={isLast ? onEntranceComplete : undefined}>
            <PromptIdeaPill label={prompt} onClick={() => submitPendingPrompt(prompt, router)} />
          </motion.div>;
    })}
    </div>;
}